import userActions from '../actions/user.actions';

const userReducer = (state, action) => {
  switch (action.type) {
    case userActions.SET_USER_NAME:
      return Object.assign({}, state, {
        agencyName: action.data.agencyName,
        agencyUserEmail: action.data.agencyUserEmail,
        isAdmin: action.data.isAdmin,
      });
    default:
      return state;
  }
};

export default userReducer;
